import { consentTypes } from "./consentDocument"
import type { ConsentRequirement, ConsentType } from "./hooks"

// Turns the member's per-consent status (from getConsentStatus) into the two things the flow needs:
// whether the consent step can be skipped, and which consents the screen must collect. Extracted from
// BookingFlow so the fetch-failure behavior is unit-testable.
//
// `consents` is undefined while the query is loading OR after it fails. On failure we deliberately
// DON'T block booking (show the screen, gate stays false) — but we must still let the member sign, so
// outstanding falls back to every known consent type. Returning [] there would send an empty payload
// that signConsent rejects (shown.min(1)), stranding the member.
export function deriveConsentGate(consents: ConsentRequirement[] | undefined): {
  alreadySignedConsent: boolean
  outstandingConsents: ConsentType[]
} {
  if (consents == null) {
    return { alreadySignedConsent: false, outstandingConsents: consentTypes }
  }
  return {
    alreadySignedConsent: consents.every((consent) => consent.satisfied),
    outstandingConsents: consents.filter((consent) => !consent.satisfied).map((consent) => consent.type)
  }
}
